import { render, staticRenderFns } from "./InsurerDetail.vue?vue&type=template&id=d2d95038&scoped=true"
import script from "./InsurerDetail.vue?vue&type=script&lang=js"
export * from "./InsurerDetail.vue?vue&type=script&lang=js"
import style0 from "./InsurerDetail.vue?vue&type=style&index=0&id=d2d95038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d95038",
  null
  
)

export default component.exports